/**
 * Built-in tag variants with their default labels and color schemes
 */
export const TAG_VARIANTS = {
	approve: {
		label: "Approve",
		colors: {
			background: "#DBF2EC",
			text: "#52C8AC",
		},
	},
	review: {
		label: "Review",
		colors: {
			background: "#FFF2D3",
			text: "#EBB228",
		},
	},
	reject: {
		label: "Reject",
		colors: {
			background: "#FFE1E1",
			text: "#F23C3C",
		},
	},
	primary: {
		label: "",
		colors: {
			background: "rgba(115, 112, 255, 0.12)",
			text: "#7370ff",
		},
	},
	hold: {
		label: "On Hold",
		colors: {
			background: "rgba(115, 112, 255, 0.12)",
			text: "#7370ff",
		}
	},
	grey: {
		label: "",
		colors: {
			background: "rgba(247, 247, 247, 1)",
			text: "#737180",
		},
	},
	blue: {
		label: "",
		colors: {
			background: "rgba(215, 234, 255, 1)",
			text: "#4392F3",
		},
	},	
} as const;
